/* ===========================================================================
   BOLD PRODUCT CARD -- colour-name sync
   ===========================================================================
   Loaded ONLY by sections/products-grid.liquid, and only when the section's
   "Card style" setting is "Bold". Nothing here is global.

   WHY THIS EXISTS
   The Bold card prints the current colourway as TEXT next to the swatches, so a
   visitor can read the colour instead of decoding a 14px dot. But the click
   handling belongs to the theme's assets/product-card.js, which swaps
   .media--first and rewrites the overlay link's href -- and does NOT touch any
   label. Verified live: clicking Rose on blade-collar-zip-polo changed the
   image and the href, and left the card reading "Navy".

   So the image said Rose while the text said Navy. This file closes that gap by
   listening for the same event on the same inputs and updating the name.

   It deliberately does NOT re-implement the image swap. One owner per concern:
   the theme owns swapping, this owns the label. A second image-swapping
   implementation would drift from the theme's and fight it on the same element.
   =========================================================================== */

(function () {
  "use strict";

  function syncColourNames(scope) {
    var root = scope || document;

    root.querySelectorAll(".bold-card").forEach(function (card) {
      var nameEl = card.querySelector(".bold-card__colour-name");
      if (!nameEl) return;
      // Guard against binding twice when both the initial pass and a
      // shopify:section:load event reach the same card.
      if (card.dataset.boldColourBound === "1") return;
      card.dataset.boldColourBound = "1";

      card.querySelectorAll(".js-color-swatches input").forEach(function (input) {
        input.addEventListener("click", function (event) {
          var el = event.currentTarget;
          if (!el || !el.checked) return;
          nameEl.textContent = el.value;
        });
      });
    });
  }

  syncColourNames(document);

  // The theme editor re-renders a section on every setting change, which
  // replaces these nodes. Re-bind so the label keeps working in the editor.
  document.addEventListener("shopify:section:load", function (event) {
    syncColourNames(event.target);
  });
})();
